<template>
  <div class="stu-container">
    <!-- 预习标识 -->
    <img
      src="@/assets/previewcourse.png"
      alt="prevview"
      class="tip-icon"
      v-if="!type"
    />
    <div class="header">
      <p
        class="title"
        style="-webkit-box-orient: vertical"
        :class="{ 'gray-font': !isUnlock }"
      >
        {{
          name
        }}
      </p>
      <img
        src="@/assets/clockin_icon_share@2x.png"
        alt="share"
        class="share"
        @click="handlerShare"
        v-if="isUnlock"
      />
      <img
        src="@/assets/catalog_icon_lock@2x.png"
        alt="lock"
        class="share"
        v-if="!isUnlock"
      />
    </div>
    <!-- 预习的时候不显示日期 -->
    <div class="date gray-font" v-if="type">
      {{ date }}
      <div class="tip" v-if="isUnlock && isNow"><span>今</span></div>
    </div>
    <template v-if="isUnlock">
      <div class="divider"></div>
      <div
        class="course-item"
        v-for="(item, index) in planList"
        :key="index"
        :style="index === planList.length - 1 ? 'padding-bottom: 0' : ''"
      >
        <div class="type">{{ item.typeName }}&nbsp;|</div>
        <div class="name">
          {{ item.name }}
        </div>
      </div>
    </template>

    <div ref="poster" class="poster" v-if="loadPoster">
      <div class="poster-top">
        <img src="@/assets/study_top.png" alt="" class="poster-top-img" />
      </div>
      <div class="poster-main">
        <div class="poster-content">
          <div class="poster-title" style="-webkit-box-orient: vertical">
            {{ name }}
          </div>
          <div class="poster-date" v-if="date">
            {{ date }}
            <div class="tip" v-if="isNow"><span>今</span></div>
          </div>
          <div class="poster-list" :style="date ? '' : 'min-height: 492px'">
            <div
              class="poster-list-item"
              v-for="(item, index) in planList"
              :key="index"
            >
              <div class="poster-type">{{ item.typeName }}&nbsp;|</div>
              <div class="poster-name">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="poster-btm">
        <img src="@/assets/study_bottom.png" alt="" class="poster-btm-img" />
      </div>
      <div class="qrcode">
        <vue-qr
          :logoSrc="require('@/assets/logo.png')"
          :text="link"
          :size="184"
          :margin="4"
          :logoScale="0.2"
          :callback="handlerQrcode"
        ></vue-qr>
      </div>
    </div>

    <img
      :src="posterUrl"
      alt="poster"
      class="poster-img"
      v-show="show && posterUrl"
    />

    <van-popup v-model="show" :lazy-render="false" round position="bottom" safe-area-inset-bottom>
      <div class="main">
        <h4 class="min-tit">主题链接</h4>
        <p class="link-text" style="-webkit-box-orient: vertical;">{{ link }}</p>
        <button class="copy-btn" @click="handlerCopy">复制链接</button>
      </div>
      <div class="cancel-btn" @click="handlerCloseDia">取消</div>
    </van-popup>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { getDataType, clipboard } from '@/common/js/utils';
import domToImage from '@/common/js/poster';
import { Popup, Toast } from 'vant';
import VueQr from 'vue-qr';

export default {
  props: {
    type: {
      validator(val) {
        // 0 => 预习模块，1 => 内容模块
        return [0, 1].indexOf(val) !== -1;
      },
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isUnlock: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    contentId: {
      // 接口里details字段里的id字段，内容ID
      type: Number,
      required: true,
    },
    seriesId: {
      // 课程id
      type: Number,
      required: true,
    },
    planList: {
      validator(val) {
        if (val instanceof Array) {
          return val.every((item) => {
            if (getDataType(item) !== 'object') {
              return false;
            }

            if (!item.name || !item.typeName || !item.objectId) {
              return false;
            }

            return true;
          });
        }

        return false;
      },
      required: true,
    },
  },
  components: {
    [Popup.name]: Popup,
    VueQr,
  },
  setup(props) {
    // 是否是今天
    const isNow = ref(false);
    if (props.date) {
      // ios系统里：new Date(2021/09/11) 只支持/符号。
      const newDate = props.date.replace(/[.-]/g, '/');
      const date = new Date(newDate);
      const currDate = new Date();

      if (date.toLocaleDateString() === currDate.toLocaleDateString()) {
        isNow.value = true;
      }
    }

    // 是否打开弹窗和显示海报
    const show = ref(false);

    const link = ref('');
    const { objectId } = props.planList[0];
    const lessonType = props.planList[0].lessonType || 0;
    const baseUrl = window.location.origin;
    link.value = `${baseUrl}/classroom/camp-play/${objectId}?cid=${props.contentId}&lt=${lessonType}&sid=${props.seriesId}`;


    // 生成海报的dom节点
    const poster = ref(null);
    const posterUrl = ref('');

    const loadPoster = ref(false);
    const handlerShare = () => {
      if (posterUrl.value) {
        show.value = true;
        return;
      }

      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '生成图片中...',
        forbidClick: true,
      });

      loadPoster.value = true;
    };

    const handlerCloseDia = () => {
      show.value = false;
    };

    const handlerCopy = () => {
      clipboard(link.value);
      show.value = false;
    };

    // 生成二维码成功，调用方法生成海报
    const handlerQrcode = () => {
      // 不用延时器，二维码会生成错误
      setTimeout(() => {
        domToImage(poster.value)
          .then((url) => {
            Toast.clear();

            posterUrl.value = url;
            show.value = true;
          })
          .catch(() => {
            Toast.clear();
            console.error('生成海报错误');
          });
      }, 100);
    };

    return {
      isNow,
      show,
      link,
      poster,
      posterUrl,
      handlerShare,
      handlerCloseDia,
      handlerCopy,
      handlerQrcode,
      loadPoster
    };
  },
};
</script>

<style lang="stylus" scoped>
$minor-color = #999;
$main-color = #191919;

.stu-container {
  position: relative;
  margin-bottom: 16px;
  padding: 16px 12px 16px 16px;
  background: #F6F7FA;
  border-radius: 4px;

  .tip-icon {
    position: absolute;
    top: -4px;
    left: 14px;
    width: 50px;
    height: 24px;
  }

  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .share {
      margin-left: 10px;
      width: 24px;
      height: 24px;
    }
  }
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  color: $main-color;
  font-weight: 500;
  word-break: break-all;
}

.gray-font {
  color: $minor-color;
}

.date {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: 12px;
  height: 12px;

  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    width: 14px;
    height: 14px;
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
    border-radius: 2px;

    span {
      font-size: 12px;
      color: #fff;
      transform: scale(0.8);
    }
  }
}

.divider {
  margin-top: 15px;
  height: 0.5px;
  background: #E7E7E7;
}

.course-item {
  display: flex;
  padding: 16px 0;

  .type {
    margin-top: 3px;
    width: 47px;
    font-size: 14px;
    color: $minor-color;
  }

  .name {
    flex: 1;
    font-size: 14px;
    color: $main-color;
    line-height: 20px;
    word-break: break-all;
  }
}

.main {
  position: relative;
  padding: 62px 20px 24px 20px;
  box-sizing border-box
  width: 100%;
  height 154px
  background: #F6F7FA;
  border-radius: 12px 12px 0px 0px;

  .min-tit {
    font-size: 12px;
    color: $minor-color;
  }

  .link-text {
    margin-top: 8px;
    margin-right: 117px;
    font-size: 16px;
    color: $main-color;
    line-height: 24px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy-btn {
    position: absolute;
    top: 84px;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 28px;
    background: #FF9645;
    border-radius: 18px;
    border: none;
    outline: none;
    font-size: 12px;
    color: #fff;
  }
}

.cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background: #fff;
  font-size: 18px;
  color: $minor-color;
  font-weight: 500;
}

.poster {
  position: fixed;
  top: -1000vh;
  left: 0;
  width: 750px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.24);
  border-radius: 8px;
  transform: translateX(-50%);

  .poster-top {
    overflow: hidden;
    height: 292px;

    .poster-top-img {
      width: 100%;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }

  .poster-main {
    width: 100%;
    background: url('../../../assets/study_middle.png');
    background-size: cover;
  }

  .poster-btm {
    position: relative;
    overflow: hidden;
    height: 342px;

    .poster-btm-img {
      position: absolute;
      bottom: 0;
      width: 100%;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
}

.poster-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 32px;
  padding: 32px;
  padding-bottom: 48px;
  box-sizing: border-box;
  min-height: 700px;
  border-radius: 8px;
  background: #fff;

  .poster-title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    width: 622px;
    word-break: break-all;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    color: #191919;
  }

  .poster-date {
    display: flex;
    margin-top: 12px;
    font-size: 24px;
    color: #999;

    .tip {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      width: 28px;
      height: 28px;
      background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
      border-radius: 4px;

      span {
        font-size: 24px;
        color: #fff;
        transform: scale(0.8);
      }
    }
  }
}

.poster-list {
  margin-top: 32px;
  width: 100%;
  min-height: 456px;
  background: #F6F7FA;
  border-radius: 8px;

  .poster-list-item {
    display: flex;
    padding: 32px;

    .poster-type {
      margin-top: 6px;
      width: 75px;
      font-size: 28px;
      color: #999;
    }

    .poster-name {
      margin-left: 16px;
      font-size: 28px;
      color: #191919;
      line-height: 40px;
    }
  }
}

.qrcode {
  position: absolute;
  bottom: 90px;
  left: calc(50% - 92px);
  width: 184px;
  height: 184px;
}

.poster-img {
  position: fixed;
  bottom: 180px;
  left: 50%;
  z-index: 9999;
  max-width: 562px;
  height: 65vh;
  transform: translateX(-50%);
  border-radius 8px
}
</style>
